import { TableBody, TableCell, TableRow } from '@/components/ui';
import { Skeleton } from '@/components/custom';

type TProps = {
	rows?: number;
};

const DataTableBodySkeleton = ({ rows = 5 }: TProps) => {
	return (
		<TableBody>
			{Array.from({ length: rows }).map((_, i) => (
				<TableRow key={i}>
					<TableCell><Skeleton className="h-12 w-16" /></TableCell>
					<TableCell><Skeleton className="h-4 w-40" /></TableCell>
					<TableCell><Skeleton className="h-6 w-24" /></TableCell>
					<TableCell><Skeleton className="h-6 w-20" /></TableCell>
					<TableCell><Skeleton className="h-4 w-28" /></TableCell>
					<TableCell><Skeleton className="h-4 w-28" /></TableCell>
					<TableCell className="text-center"><Skeleton className="h-4 w-10 mx-auto" /></TableCell>
					<TableCell><Skeleton className="h-4 w-14" /></TableCell>
					<TableCell className="text-right"><Skeleton className="h-8 w-8 ml-auto" /></TableCell>
				</TableRow>
			))}
		</TableBody>
	);
};

export default DataTableBodySkeleton;
